var screenMob = 600,
	screenTab = 900,
	w = window,
	ww = w.innerWidth;

window.addEventListener('resize', function() {
	ww = w.innerWidth;
});
